export const environment = {
  production: true,
  portableUrl: "https://echo-portable.rosecaregroup.co.uk",
  desktopUrl: "https://echo.rosecaregroup.co.uk",
  apiUrl: "https://api.echo.rosecaregroup.co.uk/api",
  wsUrl: "wss://ws.rosecaregroup.co.uk",
  apiVersion: 7.0,
  frontEndBuild: 20260504.12,
  beta: false,
};
